export default __webpack_public_path__ + "images/hipages-logo.da59d79665f4131bf03b3c595b23a034.svg";